import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";

export const getWishlistProducts = createAsyncThunk("utils/getwishlist", async () => {
  try {
    const response = await axios.get(`${baseUrl}WishList/api/v1/getWishListbyWebUser/${localStorage.getItem("UserRowId")}`);
    console.log("wish list products resonse ", response);
    return response;
  } catch (error) {
    console.error("Error fetching wishlist products:", error);
    throw error;
  }
});
